<mat-toolbar color="medium">
    <h4>{{ title }}</h4>
    <span class="fill-remaining-space"></span>
    <button mat-raised-button (click)="onClose()" color="warn" size="small">
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
    </button>
</mat-toolbar>

<mat-dialog-content class="mat-typography">

    <mat-table #table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="photoUrl">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="sm:ml-6 xs:ml-6">
                {{'TAG.FIELDS.PHOTOURL'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let data" class="xs:ml-6 sm:ml-6">
                <img class="w-full h-full object-cover" [src]="getPhotoLink(data.photoUrl)"
                    (error)="errorHandler($event)" alt="{{data.name}}">
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tagType" class="xs:ml-6">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "TAG.FIELDS.TAGTYPE" | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let data" class="md:mt-0">
                {{data.tagType }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="group" class="xs:ml-6">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "TAG.FIELDS.GROUP" | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let data" class="md:mt-0">
                {{data.group }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="priority" class="xs:ml-6">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "TAG.FIELDS.PRIORITY" | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let data" class="md:mt-0">
                {{data.priority }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="trackingItemDescription">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-md>
                {{ "TAG.FIELDS.TRACKING_ITEM" | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let data" fxHide fxShow.gt-md>
                {{data.trackingItemDescription}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt" class="hidden md:block md:mt-8">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:block md:mt-8">
                {{'SYSTEM.RECORD.CREATED_ON'|translate}}</mat-header-cell>
            <mat-cell *matCellDef="let data" class="hidden md:block md:mt-2">
                {{data.createdAt | relativeTime }}
            </mat-cell>
        </ng-container>

        <mat-header-row class="bg-gray-100" *matHeaderRowDef="displayedColumns; sticky:true">
        </mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>

        <mat-row *matNoDataRow>
            <app-no-record-found [isRequesting]="isRequesting"></app-no-record-found>
        </mat-row>

    </mat-table>

    <br />

    <mat-divider></mat-divider>

    <span class="fill-remaining-space"></span>

    <mat-paginator #paginator [length]="itemTotal" [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200, 400, 1000]" showFirstLastButtons="true">
    </mat-paginator>
</mat-dialog-content>
